<template>
    <div class="hours-tabs d-flex" role="tablist">
        <button
            v-for="tab in tabs"
            :key="tab.id"
            type="button"
            role="tab"
            class="hours-tab"
            :class="{ active: tab.id === activeTab }"
            :aria-selected="String(tab.id === activeTab)"
            @click="$emit('select', tab.id)"
        >
            {{ tab.label }}
        </button>
    </div>
</template>

<script>
    import { TAB_DEFINITIONS } from '../../views/hours/hoursTabs.js';

    export default {
        name: 'HoursTabs',
        props: {
            activeTab: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                tabs: TAB_DEFINITIONS
            };
        }
    }
</script>

<style scoped>
    .hours-tabs {
        gap: 1rem;
    }
    .hours-tab {
        padding: .6rem 1.6rem;
        font-size: 1.4rem;
        font-weight: 600;
        line-height: 1.5;
        color: #146F70;
        background-color: #FFF;
        border: 1px solid #146F70;
        border-radius: 10px;
        cursor: pointer;
    }
    .hours-tab:hover {
        background-color: #E8F1F1;
    }
    .hours-tab.active {
        color: #FFF;
        background-color: #146F70;
    }
</style>
